// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { AiOnboardingSuggestionDrawer_AiSuggestionFragment } from './aiOnboardingSuggestionDrawer.fragments.generated';
import { gql } from '@apollo/client';
import { AiOnboardingSuggestionDrawer_AiSuggestionFragmentDoc } from './aiOnboardingSuggestionDrawer.fragments.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type FetchSuggestionForDrawerQueryVariables = Types.Exact<{
  suggestionId: Types.Scalars['ID']['input'];
}>;


export type FetchSuggestionForDrawerQuery = { __typename?: 'Query', aiSuggestions: { __typename?: 'AISuggestionConnection', edges?: Array<{ __typename?: 'AISuggestionEdge', node?: (
        { __typename?: 'AISuggestion' }
        & AiOnboardingSuggestionDrawer_AiSuggestionFragment
      ) | null } | null> | null } };

export const Operations = {
  Query: {
    FetchSuggestionForDrawer: 'FetchSuggestionForDrawer' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const FetchSuggestionForDrawerDocument = gql`
    query FetchSuggestionForDrawer($suggestionId: ID!) {
  aiSuggestions(where: {id: $suggestionId}) {
    edges {
      node {
        ...AIOnboardingSuggestionDrawer_AISuggestion
      }
    }
  }
}
    ${AiOnboardingSuggestionDrawer_AiSuggestionFragmentDoc}`;

/**
 * __useFetchSuggestionForDrawerQuery__
 *
 * To run a query within a React component, call `useFetchSuggestionForDrawerQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchSuggestionForDrawerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchSuggestionForDrawerQuery({
 *   variables: {
 *      suggestionId: // value for 'suggestionId'
 *   },
 * });
 */
export function useFetchSuggestionForDrawerQuery(baseOptions: Apollo.QueryHookOptions<FetchSuggestionForDrawerQuery, FetchSuggestionForDrawerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchSuggestionForDrawerQuery, FetchSuggestionForDrawerQueryVariables>(FetchSuggestionForDrawerDocument, withFetchPolicyContext(options));
      }
export function useFetchSuggestionForDrawerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchSuggestionForDrawerQuery, FetchSuggestionForDrawerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchSuggestionForDrawerQuery, FetchSuggestionForDrawerQueryVariables>(FetchSuggestionForDrawerDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useFetchSuggestionForDrawerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FetchSuggestionForDrawerQuery, FetchSuggestionForDrawerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchSuggestionForDrawerQuery, FetchSuggestionForDrawerQueryVariables>(FetchSuggestionForDrawerDocument, withFetchPolicyContext(options));
        }
export type FetchSuggestionForDrawerQueryHookResult = ReturnType<typeof useFetchSuggestionForDrawerQuery>;
export type FetchSuggestionForDrawerLazyQueryHookResult = ReturnType<typeof useFetchSuggestionForDrawerLazyQuery>;
export type FetchSuggestionForDrawerSuspenseQueryHookResult = ReturnType<typeof useFetchSuggestionForDrawerSuspenseQuery>;
export type FetchSuggestionForDrawerQueryResult = Apollo.QueryResult<FetchSuggestionForDrawerQuery, FetchSuggestionForDrawerQueryVariables>;